/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const reducer = (state = {}, action) => {
  switch (action.type) {
    case 'DISPUTE_DETAILS':
      return { ...state, disputeDetails: action.payload };
    case 'ASSIGN_ALL_TO_DEFAULT':
      return { ...state, assignDefault: action.payload };
    case 'FROM_MAIL':
      return { ...state, fromMailId: action.payload };
    case 'MEDIA_DATA':
      return { ...state, mediaData: action.payload };
    case 'CLEAR_REDUX_ASS_DTL':
      return {};
    default:
      return state;
  }
};

export default reducer;
